












module.exports =
  name: 'error_404'
  metaInfo:
    title: '(ノ°Д°）ノ︵ ┻━┻'
